const comments = [
  {
    name: '漫画迷小陈',
    avatar: 'C',
    text: '星球漫画真的是我用过最好用的免费漫画网站！下拉式阅读太流畅了，而且更新速度超快，每天都有新内容看。强烈推荐给所有喜欢看漫画的朋友！',
    time: '3天前',
    likes: '2.3k',
  },
  {
    name: '追更达人阿杰',
    avatar: 'J',
    text: '从大学开始就在星球漫画追更了，资源真的超全，想看的免费漫画基本都能找到。不用注册就能直接看，这点太良心了。希望平台越来越好！',
    time: '5天前',
    likes: '1.8k',
  },
  {
    name: '日漫爱好者小雨',
    avatar: 'Y',
    text: '作为一个看了十几年漫画的老读者，星球漫画的阅读体验真的很棒。分类清晰、加载快速、画质清晰，手机上看起来也很舒服，是我目前最推荐的在线漫画阅读平台。',
    time: '1周前',
    likes: '1.5k',
  },
  {
    name: '新入坑的小白',
    avatar: 'B',
    text: '刚入坑漫画不久，在星球漫画找到了很多好看的免费漫画。专题分类功能对新读者特别友好，按题材就能找到感兴趣的作品。已经安利给身边好多朋友了！',
    time: '2周前',
    likes: '986',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          读者热评
        </h2>
        <p className="text-foreground-600 text-sm text-center mb-10 md:mb-14 max-w-xl mx-auto">
          来自漫画爱好者的真实阅读反馈
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-[1000px] mx-auto">
          {comments.map((comment, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl p-5 md:p-6"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-primary-200 flex items-center justify-center shrink-0">
                  <span className="font-heading text-sm text-primary-700">
                    {comment.avatar}
                  </span>
                </div>
                <div>
                  <h3 className="font-heading text-sm text-foreground-900">
                    {comment.name}
                  </h3>
                  <span className="text-xs text-foreground-400">{comment.time}</span>
                </div>
              </div>
              <p className="text-foreground-600 text-sm leading-relaxed mb-3">
                {comment.text}
              </p>
              <div className="flex items-center gap-1 text-foreground-400">
                <i className="ri-thumb-up-line text-xs"></i>
                <span className="text-xs">{comment.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}